module.exports = __webpack_public_path__ + "static/business-e9dc8986272dd024cedbf022837b25e2.png";